export const BULLYING_PATH = 'recognizing-bullying-and-harassment'
export const INSTANCE_MODE = 'teach'
export const LOCALE_US = 'en-US'
export const PREVIEW_MODE = 'preview'
export const UNIT_RBH = 'unitrbh'
